var _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgStatistic = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1875 -1279)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0,
    width: 24,
    height: 24,
    transform: "translate(1899 1279) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    width: 2,
    height: 16,
    rx: 1,
    transform: "translate(1892 1283)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    width: 2,
    height: 11,
    rx: 1,
    transform: "translate(1888 1288)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    width: 2,
    height: 4,
    rx: 1,
    transform: "translate(1884 1295)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    width: 2,
    height: 8,
    rx: 1,
    transform: "translate(1880 1291)"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStatistic, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/statistic.494562a5.svg";
export { ForwardRef as ReactComponent };